module.exports = __webpack_public_path__ + "media/DOE.cc3b3b55.mp4";